import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import moment from 'moment';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactSelectMaterialUi from 'react-select-material-ui';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import GochiEventSettingConfirm from './GochiEventSettingConfirm';
import { sendLogin } from '../../auth/Auth';
import {
  getGochiEventSetting,
  addGochiEventSetting,
  editGochiEventSetting
} from '../../actions/GochiEventSetting';
import ValidationText from '../../components/atoms/ValidationText';
import { getOptionGroups } from '../../actions/Options';
import menuEventTypes from '../../constants/MenuEventType';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 5px'
    },
    display: 'flex',
    flexDirection: 'column'
  },
  editTable: {
    width: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none'
    }
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    }
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  width100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
      padding: 0
    }
  },
  flexCol: {
    display: 'flex',
    alignItems: 'end'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    () => {},
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiEventSetting,
          addGochiEventSetting,
          editGochiEventSetting,
          getOptionGroups
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAddProgress', 'updateOpenAddProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('gochiEventId', 'setGochiEventId', null),
  withState('gochiEventName', 'setGochiEventName', null),
  withState('startDate', 'setStartDate', null),
  withState('endDate', 'setEndDate', null),
  withState('eventFeeRate', 'setEventFeeRate', null),
  withState('supportPricePercentRate', 'setSupportPricePercentRate', null),
  withState('maxTotalAmount', 'setMaxTotalAmount', null),
  withState('maxTotalAmountPerOrder', 'setMaxTotalAmountPerOrder', null),
  withState('maxTotalAmountShop', 'setMaxTotalAmountShop', null),
  withState('shopFeeRate', 'setShopFeeRate', null),
  withState('gochiExpriedDate', 'setGochiExpriedDate', null),
  withState('gochiStartDate', 'setGochiStartDate', null),
  withState('dataErrors', 'setDataErrors', {}),
  withState('groups', 'setGroups', []),
  withState('gochiEventType', 'setGochiEventType', menuEventTypes[0].id),
  withState('groupId', 'setGroupId', 0),
  withState('groupsError', 'setGroupsError', ''),
  withState('groupName', 'setGroupName', ''),

  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionGroups().then(data => {
        this.props.checkSession(data);
        this.props.setGroups(data.payload.list);
      });
      if (this.props.editInput) {
        this.props.setGochiEventType(this.props.editInput.eventCategory);
        this.props.setGroupId(this.props.editInput.groupId);
        this.props.setGroupName(
          (this.props.editInput.group &&
            this.props.editInput.group.groupName) ||
            ''
        );
        this.props.setGochiEventName(this.props.editInput.gochiEventName);
        this.props.setGochiEventId(this.props.editInput.gochiEventId);
        this.props.setStartDate(
          moment(this.props.editInput.startDate).format('YYYY-MM-DDTHH:mm:ss')
        );
        this.props.setEndDate(
          moment(this.props.editInput.endDate).format('YYYY-MM-DDTHH:mm:ss')
        );
        this.props.setEventFeeRate(
          String(this.props.editInput.eventFeeRate || '')
        );
        this.props.setSupportPricePercentRate(
          String(this.props.editInput.supportPricePercentRate || '')
        );
        this.props.setMaxTotalAmount(
          String(this.props.editInput.maxTotalAmount || '')
        );
        this.props.setMaxTotalAmountPerOrder(
          String(this.props.editInput.maxTotalAmountPerOrder || '')
        );
        this.props.setMaxTotalAmountShop(
          String(this.props.editInput.maxTotalAmountShop || '')
        );
        this.props.setShopFeeRate(
          String(this.props.editInput.shopFeeRate || '')
        );
        if (this.props.editInput.gochiExpriedDate) {
          this.props.setGochiExpriedDate(
            moment(this.props.editInput.gochiExpriedDate).format(
              'YYYY-MM-DDTHH:mm:ss'
            )
          );
        }
        if (this.props.editInput.gochiStartDate) {
          this.props.setGochiStartDate(
            moment(this.props.editInput.gochiStartDate).format(
              'YYYY-MM-DDTHH:mm:ss'
            )
          );
        }
      }
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    searchKey, // roles,
    openAddConfirm,
    updateOpenAdd,
    updateOpenAddConfirm,
    openAddProgress,
    updateOpenAddProgress,
    loading,
    updateLoading,
    isAddSuccess,
    updateIsAddSuccess,
    resultMessage,
    setResultMessage,
    gochiEventId,
    gochiEventName,
    setGochiEventName,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    eventFeeRate,
    setEventFeeRate,
    supportPricePercentRate,
    setSupportPricePercentRate,
    maxTotalAmount,
    setMaxTotalAmount,
    maxTotalAmountPerOrder,
    setMaxTotalAmountPerOrder,
    maxTotalAmountShop,
    setMaxTotalAmountShop,
    shopFeeRate,
    setShopFeeRate,
    gochiExpriedDate,
    setGochiExpriedDate,
    gochiStartDate,
    setGochiStartDate,
    dataErrors,
    setDataErrors,
    editInput,
    groups,
    gochiEventType,
    setGochiEventType,
    groupId,
    setGroupId,
    groupsError,
    setGroupsError,
    groupName,
    setGroupName
  }) => {
    const getCurrentData = () => {
      return {
        gochiEventId,
        gochiEventName,
        startDate,
        endDate,
        eventFeeRate,
        supportPricePercentRate:
          gochiEventType === 2 ? supportPricePercentRate : undefined,
        maxTotalAmount: gochiEventType === 2 ? maxTotalAmount : undefined,
        maxTotalAmountPerOrder:
          gochiEventType === 2 ? maxTotalAmountPerOrder : undefined,
        maxTotalAmountShop:
          gochiEventType === 2 ? maxTotalAmountShop : undefined,
        shopFeeRate,
        gochiExpriedDate:
          gochiExpriedDate === 'Invalid date' && gochiEventType === 1
            ? null
            : gochiExpriedDate,
        gochiStartDate:
          gochiStartDate === 'Invalid date' && gochiEventType === 1
            ? null
            : gochiStartDate,
        eventCategory: gochiEventType,
        groupId: gochiEventType === 1 ? groupId : undefined
      };
    };

    const validGroups = () => {
      const value = groupId;
      if (gochiEventType === menuEventTypes[1].id && value === 0) {
        setGroupsError('必須項目です。');
        return 1;
      }
      setGroupsError('');
      setGroupId(value);
      return 0;
    };

    const validateInput = ({ name, required, isNumberic, notUpdateState }) => {
      const stateValues = getCurrentData();
      let res = { error: '', value: 0 };
      if (
        (name === 'gochiStartDate' || name === 'gochiExpriedDate') &&
        stateValues.gochiStartDate &&
        stateValues.gochiExpriedDate &&
        new Date(stateValues.gochiStartDate) >
          new Date(stateValues.gochiExpriedDate)
      ) {
        if (!notUpdateState) {
          setDataErrors({
            ...dataErrors,
            gochiStartDate: '正しく日付を選んでください',
            gochiExpriedDate: '正しく日付を選んでください'
          });
        }
        res = { error: '正しく日付を選んでください', value: 1, name };
      } else if (
        (name === 'startDate' || name === 'endDate') &&
        stateValues.startDate &&
        stateValues.endDate &&
        new Date(stateValues.startDate) > new Date(stateValues.endDate)
      ) {
        if (!notUpdateState) {
          setDataErrors({
            ...dataErrors,
            startDate: '正しく日付を選んでください',
            endDate: '正しく日付を選んでください'
          });
        }
        res = { error: '正しく日付を選んでください', value: 1, name };
      } else if (
        name === 'supportPricePercentRate' &&
        supportPricePercentRate !== null &&
        !/^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(supportPricePercentRate)
      ) {
        setDataErrors({
          ...dataErrors,
          supportPricePercentRate: 'プレミアム率を正しくご入力ください。'
        });
      } else if (
        required &&
        (!stateValues[name] ||
          (stateValues[name].trim && stateValues[name].trim() === ''))
      ) {
        if (!notUpdateState) {
          setDataErrors({ ...dataErrors, [name]: '必須項目です。' });
        }
        res = { error: '必須項目です。', value: 1, name };
      } else if (
        isNumberic &&
        stateValues[name] &&
        stateValues[name] !== String(parseFloat(stateValues[name]))
      ) {
        if (!notUpdateState) {
          setDataErrors({
            ...dataErrors,
            [name]: '半角数字のみ入力してください。'
          });
        }

        res = { error: '半角数字のみ入力してください。', value: 1, name };
      } else if (!notUpdateState) {
        if (name === 'startDate' || name === 'endDate') {
          setDataErrors(_.omit(dataErrors, ['startDate', 'endDate']));
        } else if (name === 'gochiStartDate' || name === 'gochiExpriedDate') {
          setDataErrors(
            _.omit(dataErrors, ['gochiStartDate', 'gochiExpriedDate'])
          );
        } else setDataErrors(_.omit(dataErrors, [name]));
      }
      return res;
    };

    const valid = () => {
      const requiredArray = [
        'gochiEventName',
        'startDate',
        'endDate',
        'gochiExpriedDate',
        'gochiStartDate'
      ];
      const newErrs = {};
      let errorCount = 0;
      _.forEach(requiredArray, req => {
        const validate = validateInput({
          name: req,
          required: !!(req !== 'gochiExpriedDate' && req !== 'gochiStartDate'),
          notUpdateState: true
        });
        if (validate.value === 1) {
          newErrs[validate.name] = validate.error;
          errorCount += 1;
        }
      });
      setDataErrors({
        ...dataErrors,
        ...newErrs
      });
      if (
        errorCount === 0 &&
        !_.size({ ...dataErrors, ...newErrs }) &&
        !validGroups()
      ) {
        return true;
      }
      return false;
    };

    const cancelAction = () => updateOpenAdd(false);
    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        updateOpenAddConfirm(true);
      }
    };
    const backAction = () => updateOpenAddConfirm(false);
    const registerAction = async () => {
      const param = {
        ...getCurrentData()
      };
      updateLoading(true);
      updateOpenAddProgress(true);
      if (editInput) {
        // edit
        const editedEventSetting = await actions
          .editGochiEventSetting(gochiEventId, param)
          .then(data => checkSession(data));

        if (editedEventSetting.type === 'EDIT_GOCHI_EVENT_SETTING_SUCCESS') {
          updateIsAddSuccess(true);
          actions
            .getGochiEventSetting(searchKey)
            .then(data => checkSession(data));
          setResultMessage('登録が完了しました。');
          updateLoading(false);
        } else {
          updateIsAddSuccess(false);
          setResultMessage('登録に失敗しました。');
          updateLoading(false);
        }
      } else {
        // add
        const addedEventSetting = await actions
          .addGochiEventSetting(param)
          .then(data => checkSession(data));

        if (addedEventSetting.type === 'ADD_GOCHI_EVENT_SETTING_SUCCESS') {
          updateIsAddSuccess(true);
          actions
            .getGochiEventSetting(searchKey)
            .then(data => checkSession(data));
          setResultMessage('登録が完了しました。');
          updateLoading(false);
        } else {
          updateIsAddSuccess(false);
          setResultMessage('登録に失敗しました。');
          updateLoading(false);
        }
      }
    };

    const progressOkAction = () => {
      if (isAddSuccess) {
        updateOpenAdd(false);
        updateOpenAddConfirm(false);
        updateOpenAddProgress(false);
      } else {
        updateOpenAddProgress(false);
      }
    };

    const otherData = { groupName };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography variant="h6">イベント登録</Typography>
          <Typography>
            下記の設定をAI&Tさんへ redmine で依頼してください。
            <br />
            ①1人の購入制限
            <br />
            ②店舗ごとの1人の購入制限
            <br />
            ③売り切れ時（イベントOFF時）に自動的にチケットが非表示になる
            <br />
            ④QRコードによる店舗選択
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.editTable}>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  required
                  label="イベント名"
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setGochiEventName(e.target.value);
                  }}
                  value={gochiEventName}
                  inputProps={{
                    maxLength: 100
                  }}
                  onBlur={() =>
                    validateInput({ name: 'gochiEventName', required: true })
                  }
                />
                <ValidationText message={dataErrors.gochiEventName} />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <Typography className={classes.description}>
                  イベント種別
                </Typography>
                <RadioGroup
                  value={gochiEventType}
                  onChange={e => {
                    setGochiEventType(parseInt(e.target.value, 10));
                  }}
                >
                  {menuEventTypes.map(type => (
                    <FormControlLabel
                      disabled={!!editInput}
                      value={type.id}
                      control={<Radio color="primary" />}
                      label={type.name}
                    />
                  ))}
                </RadioGroup>
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>
            {gochiEventType === menuEventTypes[1].id && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <ReactSelectMaterialUi
                    required
                    label="対象グループ*"
                    disabled={!!editInput}
                    className={classes.textField}
                    defaultValue={groupId}
                    value={groupId}
                    options={groups.map(item => ({
                      label: item.groupName,
                      value: item.groupId
                    }))}
                    margin="normal"
                    onChange={(v, o) => {
                      setGroupId(Number(v));
                      setGroupName(o.label);
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致するグループがありません',
                      msgNoOptionsAvailable:
                        '名前が部分一致するグループがありません'
                    }}
                    onBlur={validGroups}
                  />
                  <ValidationText message={groupsError} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <div className={classes.flexCol}>
                  <TextField
                    required
                    label="公開時間"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      const newVal = moment(e.target.value);
                      const res = startDate ? moment(startDate) : moment();
                      res.set({
                        year: newVal.get('year'),
                        date: newVal.get('date'),
                        month: newVal.get('month')
                      });
                      setStartDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                    }}
                    onBlur={() =>
                      validateInput({ name: 'startDate', required: true })
                    }
                    value={
                      startDate ? moment(startDate).format('YYYY-MM-DD') : null
                    }
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      min: moment().format('YYYY-MM-DD'),
                      max: !endDate ? '' : endDate
                    }}
                  />
                  <TextField
                    type="time"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      const newVal = moment(e.target.value, 'HH:mm:ss');
                      const res = startDate ? moment(startDate) : moment();
                      res.set({
                        hour: newVal.get('hour'),
                        minute: newVal.get('minute'),
                        second: newVal.get('second')
                      });
                      setStartDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                    }}
                    onBlur={() =>
                      validateInput({ name: 'startDate', required: true })
                    }
                    value={
                      startDate ? moment(startDate).format('HH:mm:ss') : null
                    }
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      step: 1,
                      max: !endDate ? '' : endDate
                    }}
                  />
                </div>
                <ValidationText message={dataErrors.startDate} />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>
            <TableRow>
              <TableCell className={classes.colLeft}>
                <RequiredButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <div className={classes.flexCol}>
                  <TextField
                    required
                    label="終了時間"
                    type="date"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      const newVal = moment(e.target.value);
                      const res = endDate ? moment(endDate) : moment();
                      res.set({
                        year: newVal.get('year'),
                        date: newVal.get('date'),
                        month: newVal.get('month')
                      });
                      setEndDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                    }}
                    onBlur={() =>
                      validateInput({ name: 'endDate', required: true })
                    }
                    value={
                      endDate ? moment(endDate).format('YYYY-MM-DD') : null
                    }
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      min: !startDate ? '' : startDate
                    }}
                  />
                  <TextField
                    type="time"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      const newVal = moment(e.target.value, 'HH:mm:ss');
                      const res = endDate ? moment(endDate) : moment();
                      res.set({
                        hour: newVal.get('hour'),
                        minute: newVal.get('minute'),
                        second: newVal.get('second')
                      });
                      setEndDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                    }}
                    onBlur={() =>
                      validateInput({ name: 'endDate', required: true })
                    }
                    value={endDate ? moment(endDate).format('HH:mm:ss') : null}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      step: 1
                    }}
                  />
                </div>
                <ValidationText message={dataErrors.endDate} />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>

            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="手数料負担率"
                  type="number"
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setEventFeeRate(e.target.value);
                  }}
                  value={eventFeeRate}
                  onBlur={() =>
                    validateInput({ name: 'eventFeeRate', isNumberic: true })
                  }
                />
                <ValidationText message={dataErrors.eventFeeRate} />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>

            {gochiEventType === 2 && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="プレミアム分"
                    type="number"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setSupportPricePercentRate(e.target.value);
                    }}
                    value={supportPricePercentRate}
                    onBlur={() =>
                      validateInput({
                        name: 'supportPricePercentRate',
                        isNumberic: true
                      })
                    }
                  />
                  <ValidationText
                    message={dataErrors.supportPricePercentRate}
                  />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}

            {gochiEventType === 2 && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="拠出予算額"
                    type="number"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMaxTotalAmount(e.target.value);
                    }}
                    value={maxTotalAmount}
                    onBlur={() =>
                      validateInput({
                        name: 'maxTotalAmount',
                        isNumberic: true
                      })
                    }
                  />
                  <ValidationText message={dataErrors.maxTotalAmount} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}

            {gochiEventType === 2 && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="一回あたりの購入上限額"
                    type="number"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMaxTotalAmountPerOrder(e.target.value);
                    }}
                    value={maxTotalAmountPerOrder}
                    onBlur={() =>
                      validateInput({
                        name: 'maxTotalAmountPerOrder',
                        isNumberic: true
                      })
                    }
                  />
                  <ValidationText message={dataErrors.maxTotalAmountPerOrder} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}

            {gochiEventType === 2 && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <TextField
                    label="1店舗あたりの購入上限額"
                    type="number"
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setMaxTotalAmountShop(e.target.value);
                    }}
                    value={maxTotalAmountShop}
                    onBlur={() =>
                      validateInput({
                        name: 'maxTotalAmountShop',
                        isNumberic: true
                      })
                    }
                  />
                  <ValidationText message={dataErrors.maxTotalAmountShop} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}

            <TableRow>
              <TableCell className={classes.colLeft}>
                <AnyButton />
              </TableCell>
              <TableCell className={classes.colRight}>
                <TextField
                  label="店舗が負担する手数料率"
                  type="number"
                  className={classes.textField}
                  margin="normal"
                  onChange={e => {
                    setShopFeeRate(e.target.value);
                  }}
                  value={shopFeeRate}
                  onBlur={() =>
                    validateInput({ name: 'shopFeeRate', isNumberic: true })
                  }
                />
                <ValidationText message={dataErrors.shopFeeRate} />
              </TableCell>
              <TableCell className={classes.width100} />
            </TableRow>
            {gochiEventType === 2 && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div className={classes.flexCol}>
                    <TextField
                      label="利用開始日"
                      type="date"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value);
                        const res = gochiStartDate
                          ? moment(gochiStartDate)
                          : moment();
                        res.set({
                          year: newVal.get('year'),
                          date: newVal.get('date'),
                          month: newVal.get('month')
                        });
                        setGochiStartDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={() =>
                        validateInput({
                          name: 'gochiStartDate',
                          required: false
                        })
                      }
                      value={
                        gochiStartDate
                          ? moment(gochiStartDate).format('YYYY-MM-DD')
                          : null
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        min: moment().format('YYYY-MM-DD'),
                        max: gochiExpriedDate || ''
                      }}
                    />
                    <TextField
                      type="time"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value, 'HH:mm:ss');
                        const res = gochiStartDate
                          ? moment(gochiStartDate)
                          : moment();
                        res.set({
                          hour: newVal.get('hour'),
                          minute: newVal.get('minute'),
                          second: newVal.get('second')
                        });
                        setGochiStartDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={() =>
                        validateInput({
                          name: 'gochiStartDate',
                          required: false
                        })
                      }
                      value={
                        gochiStartDate
                          ? moment(gochiStartDate).format('HH:mm:ss')
                          : null
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 1
                      }}
                    />
                  </div>
                  <ValidationText message={dataErrors.gochiStartDate} />
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}
            {gochiEventType === 2 && (
              <TableRow>
                <TableCell className={classes.colLeft}>
                  <AnyButton />
                </TableCell>
                <TableCell className={classes.colRight}>
                  <div className={classes.flexCol}>
                    <TextField
                      label="利用期限"
                      type="date"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value);
                        const res = gochiExpriedDate
                          ? moment(gochiExpriedDate)
                          : moment();
                        res.set({
                          year: newVal.get('year'),
                          date: newVal.get('date'),
                          month: newVal.get('month')
                        });
                        setGochiExpriedDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={() =>
                        validateInput({
                          name: 'gochiExpriedDate',
                          required: false
                        })
                      }
                      value={
                        gochiExpriedDate
                          ? moment(gochiExpriedDate).format('YYYY-MM-DD')
                          : null
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        min: gochiStartDate || ''
                      }}
                    />
                    <TextField
                      type="time"
                      className={classes.textField}
                      margin="normal"
                      onChange={e => {
                        const newVal = moment(e.target.value, 'HH:mm:ss');
                        const res = gochiExpriedDate
                          ? moment(gochiExpriedDate)
                          : moment();
                        res.set({
                          hour: newVal.get('hour'),
                          minute: newVal.get('minute'),
                          second: newVal.get('second')
                        });
                        setGochiExpriedDate(res.format('YYYY-MM-DDTHH:mm:ss'));
                      }}
                      onBlur={() =>
                        validateInput({
                          name: 'gochiExpriedDate',
                          required: false
                        })
                      }
                      value={
                        gochiExpriedDate
                          ? moment(gochiExpriedDate).format('HH:mm:ss')
                          : null
                      }
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 1
                      }}
                    />
                  </div>
                  <ValidationText message={dataErrors.gochiExpriedDate} />
                  <div>
                    原則6ヶ月以内での期限設定をお願いします。6ヶ月を超える場合は、規約の変更が必須です。十分注意してください
                  </div>
                </TableCell>
                <TableCell className={classes.width100} />
              </TableRow>
            )}
          </Table>
        </Paper>
        <div>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openAddConfirm}>
          <GochiEventSettingConfirm
            backAction={backAction}
            registerAction={registerAction}
            dataConfirm={getCurrentData()}
            openAddProgress={openAddProgress}
            otherData={otherData}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            title={editInput ? 'イベントを編集' : 'イベント登録'}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
